//
//
//
//
//
//
//
//
//
//
//
//

import {picLoadingGif} from '@/tools/CDNpics'
export default {
  data () {
    return {
      picLoadingGif,
      show: false,
      layer: false
    }
  }
}
